<div class="header">
  <h2>Gestione <strong>Utenti</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li>Utenti</li>
      <li class="active">Gestione Utenti</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-table"></i> Lista <strong>Utenti</strong></h3>
      </div>
      <div class="panel-content">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2" style="padding-top: 5px;">
            <label for="items-per-page">Mostra</label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-3">
            <div class="form-group">
              <input [(ngModel)]="paginationConfig.itemsPerPage" (change)="paginationConfig.currentPage = 1"
                     class="form-control input-sm form-white"
                     id="items-per-page" name="items-per-page" type="number">
            </div>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-3" style="padding-top: 5px;">
            <label for="items-per-page">{{ paginationConfig.itemsPerPage > 1 ? 'risultati' : 'risultato' }}</label>
          </div>
          <div class="col-md-5 col-md-offset-1 col-sm-5 col-sm-offset-1 col-xs-12">
            <div class="row">
              <div class="col-md-3 col-sm-3 col-xs-2" style="padding-top: 5px;">
                <label for="user-filter">
                  Cerca:
                </label>
              </div>
              <div class="col-md-9 col-sm-9 col-xs-10">
                <input [(ngModel)]="userFilterValue" class="form-control input-sm form-white"
                       id="user-filter" name="user-filter" type="text">
              </div>
            </div>
          </div>
        </div>
        <div style="overflow-x:auto;">
          <table class="table table-hover">
            <thead>
            <tr>
              <th style="width: 40%;">
                Username
                <div class="form-group hidden-xs">
                  <div class="col-sm-6 prepend-icon">
                    <input [(ngModel)]="usernameFilterValue" type="text" class="form-control form-white" placeholder="Cerca Username...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div>
              </th>
              <th style="width: 20%;">
                Ruolo
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="roleFilterValue" type="text" class="form-control form-white" placeholder="Cerca Ruolo...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div></th>
              <th style="width: 20%;">
                Attivo
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="activeFilterValue" type="text" class="form-control form-white" placeholder="Cerca Attivo...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div>
              </th>
              <th class="text-right" style="width: 20%;">Azioni</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of users |
                  userFilter: userFilterValue |
                  usernameFilter: usernameFilterValue |
                  roleFilter: roleFilterValue |
                  activeFilter: activeFilterValue |
                  paginate: paginationConfig">
              <td>{{ user.username }} </td>
              <td>{{ user.role.value }}</td>
              <td>{{ user.active ? "Sì" : "No" }}</td>
              <td class="text-right">
                <a class="edit btn btn-sm btn-primary" [routerLink]="['/user/' + user.id_user]">
                  <i class="icon-user"></i></a>
                <a class="edit btn btn-sm btn-default" [routerLink]="['/user/update/' + user.id_user]">
                  <i class="icon-note"></i></a>
                <a *ngIf="user.active; else userActivate" class="edit btn btn-sm btn-warning" (click)="openDeactivateUserModal(user)">
                  <i class="icons-office-48"></i>
                </a>
                <a class="delete btn btn-sm btn-danger" (click)="openDeleteUserModal(user)">
                  <i class="icons-office-57"></i>
                </a>
                <ng-template #userActivate>
                  <a class="edit btn btn-sm btn-success" (click)="openActivateUserModal(user)">
                    <i class="icons-office-51"></i>
                  </a>
                </ng-template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <pagination-controls [maxSize]="paginationParams.maxSize"
                             [autoHide]="paginationParams.autoHide"
                             [responsive]="paginationParams.responsive"
                             [previousLabel]="paginationLabels.previousLabel"
                             [nextLabel]="paginationLabels.nextLabel"
                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                             (pageChange)="onPageChange($event)"
                             (pageBoundsCorrection)="onPageBoundsCorrection($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>
